import { render, staticRenderFns } from "./WZOverlayV2.vue?vue&type=template&id=5fd2ba0c&"
import script from "./WZOverlayV2.vue?vue&type=script&lang=js&"
export * from "./WZOverlayV2.vue?vue&type=script&lang=js&"
import style0 from "./WZOverlayV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports